'use strict';

module.exports = {
    all: 0,
    volumeFunding: 1,
    lumpFunding: 2,
    variableFunding: 3,
};
